module.exports = __webpack_public_path__ + "img/gyant_xl_light_natural_ba_detail_rsh1.54eab311.jpg";